module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/HourlyPrecipitation50/Kanagawa_HourlyPrecipitation50_MRI_RCP85_End.png";